import { render, staticRenderFns } from "./AnswerUpdatetext.vue?vue&type=template&id=fbdb1f34&scoped=true&"
import script from "./AnswerUpdatetext.vue?vue&type=script&lang=js&"
export * from "./AnswerUpdatetext.vue?vue&type=script&lang=js&"
import style0 from "./AnswerUpdatetext.vue?vue&type=style&index=0&id=fbdb1f34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdb1f34",
  null
  
)

export default component.exports